<template>
  <div :style="{ height: isAppCookieBannerVisible && !$device.isDesktop ? `${COOKIE_BANNER_HEIGHT}px` : '0px' }">
    <v-system-bar
      v-if="isAppCookieBannerVisible && !$device.isDesktop"
      color="ui-kit-bg-primary"
      class="px-0"
      :height="COOKIE_BANNER_HEIGHT"
    >
      <div class="py-2 px-2 w-100 d-flex align-center">
        <div class="py-1 text-body-2 text-start">
          Мы используем <a
            href="/documents/cookie-2026.pdf"
            class="text-decoration-none text-primary"
            target="_blank"
          >cookie</a> и Яндекс.Метрику, чтобы сайт работал лучше
        </div>
        <v-btn
          width="96"
          class="ml-auto px-3 bg-text text-white"
          @click="accept"
        >
          Хорошо
        </v-btn>
      </div>
    </v-system-bar>
    <div
      v-else-if="isAppCookieBannerVisible && $device.isDesktop"
      class="cookie-desktop-banner"
    >
      <v-sheet
        rounded="lg"
        color="ui-kit-bg-primary"
        class="py-2 px-4 cookie-desktop__sheet"
      >
        <div class="d-flex align-center justify-space-between ga-4">
          <div class="py-1 text-body-2 text-start">
            Мы используем <a
              href="/documents/cookie-2026.pdf"
              class="text-decoration-none text-primary"
              target="_blank"
            >cookie</a> и Яндекс.Метрику, чтобы сайт работал лучше
          </div>

          <v-btn
            width="96"
            class="ml-auto px-3 bg-text text-white"
            @click="accept"
          >
            Хорошо
          </v-btn>
        </div>
      </v-sheet>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { COOKIE_CONSENT_STORAGE_KEY } from '~/constants/localeStore'
import { COOKIE_BANNER_HEIGHT } from '~/constants/main'

const { isAppCookieBannerVisible } = storeToRefs(useMainStore())
const COOKIE_CONSENT_STORAGE_VALUE = 'accepted'

function getLocalConsent(): boolean {
  return localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === COOKIE_CONSENT_STORAGE_VALUE
}

function setLocalConsent() {
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, COOKIE_CONSENT_STORAGE_VALUE)
}

function accept() {
  setLocalConsent()
  isAppCookieBannerVisible.value = false
}

onMounted(() => {
  if (!getLocalConsent()) {
    isAppCookieBannerVisible.value = true
  }
})
</script>

<style scoped lang="scss">
.cookie-desktop-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  display: flex;
  justify-content: center;
  z-index: 1000;

  &__sheet {
    width: 100%;
    max-width: 535px;
  }
}
</style>
